
  var _styles = {
  "coupon-usage-record__container": {
    "width": "10rem",
    "height": "12.82667rem",
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "space-between",
    "alignItems": "center",
    "paddingTop": "0.48rem",
    "paddingRight": "0.42667rem",
    "paddingBottom": 0,
    "paddingLeft": "0.42667rem"
  },
  "coupon-usage-record__empty-content": {
    "paddingTop": "1.93333rem",
    "alignItems": "center"
  },
  "coupon-usage-record__empty-text": {
    "color": "rgba(36,17,3,0.7019607843)",
    "fontFamily": "PingFang SC",
    "fontWeight": "400",
    "fontSize": "0.32rem",
    "lineHeight": "24px",
    "WebkitTextDecoration": "NONE",
    "textDecoration": "NONE",
    "position": "relative",
    "top": "-0.77333rem",
    "opacity": 0.7
  },
  "coupon-usage-record__scroll-view": {
    "height": "11.33333rem",
    "flex": 1
  },
  "coupon-usage-record__content": {
    "alignItems": "center",
    "width": "9.14667rem"
  },
  "tab-container": {
    "width": "100%",
    "height": "0.50667rem",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "space-between",
    "marginBottom": "0.48rem",
    "marginLeft": "0.16rem",
    "paddingRight": "0.8rem"
  },
  "tab-item": {
    "alignItems": "center",
    "justifyContent": "space-between"
  },
  "tab-text": {
    "color": "rgb(46,31,0)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "opacity": 0.7
  },
  "tab-text-append": {
    "marginLeft": "0.10667rem"
  },
  "tab-line": {
    "width": "0.53333rem",
    "height": "0.10667rem",
    "borderRadius": "0.26667rem"
  },
  "coupon-list-title": {
    "position": "relative",
    "top": 0,
    "height": "0.64rem"
  },
  "coupon-usage-item-wrap": {
    "width": "9.14667rem",
    "height": "2.13333rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "marginBottom": "0.26667rem"
  },
  "coupon-usage-item-left": {
    "width": "2.48rem"
  },
  "coupon-usage-amount-wrap": {
    "display": "flex",
    "alignItems": "baseline"
  },
  "coupon-usage-item-price": {
    "width": "100%",
    "height": "0.74667rem",
    "color": "rgb(255,45,25)",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "flex-end",
    "justifyContent": "center",
    "marginLeft": "0.02667rem",
    "fontFamily": "MTNewDigitalDisplay-Bold",
    "fontWeight": "700",
    "fontSize": "0.72rem"
  },
  "coupon-usage-item-price-symbol": {
    "height": "0.45333rem",
    "color": "rgb(255,45,25)",
    "fontSize": "0.32rem",
    "fontWeight": "600",
    "fontFamily": "PingFang SC"
  },
  "coupon-usage-item-price-value": {
    "color": "rgb(255,45,25)",
    "fontSize": "0.69333rem",
    "height": "0.72rem",
    "fontWeight": "700"
  },
  "coupon-usage-item-condition": {
    "width": "100%",
    "height": "0.37333rem",
    "marginTop": "0.18667rem",
    "marginBottom": "0.05333rem",
    "fontWeight": "400",
    "color": "rgb(255,45,25)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.29333rem",
    "lineHeight": "0.37333rem",
    "textAlign": "center"
  },
  "coupon-usage-item-mid": {
    "flex": 1,
    "alignItems": "flex-start",
    "marginLeft": "0.34667rem"
  },
  "coupon-usage-item-title": {
    "width": "100%",
    "height": "0.42667rem",
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.32rem",
    "lineHeight": "0.42667rem",
    "marginBottom": "0.08rem"
  },
  "coupon-usage-item-limit": {
    "width": "100%",
    "height": "0.37333rem",
    "fontWeight": "400",
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.29333rem",
    "lineHeight": "0.37333rem",
    "textAlign": "left"
  },
  "coupon-usage-item-right": {
    "width": "1.6rem",
    "alignItems": "center",
    "justifyContent": "center",
    "height": "0.37333rem",
    "marginRight": "0.32rem"
  },
  "coupon-usage-item-status": {
    "width": "100%",
    "color": "rgb(170,172,178)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.37333rem",
    "height": "0.53333rem",
    "textAlign": "center",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "coupon-usage-item-status-btn": {
    "height": "0.74667rem",
    "paddingTop": 0,
    "paddingRight": "0.21333rem",
    "paddingBottom": 0,
    "paddingLeft": "0.21333rem",
    "borderRadius": "0.37333rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "coupon-usage-item-status-btn-inner": {
    "width": "1.6rem",
    "height": "0.8rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "borderRadius": "1.22667rem",
    "backgroundColor": "rgb(255,224,0)"
  },
  "coupon-usage-item-status-text": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.32rem",
    "lineHeight": "0.42667rem"
  }
};



  module.exports = _styles;
  